var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// src/useApolloClient.ts
import { hasInjectionContext, inject } from "vue-demi";
var DefaultApolloClient = Symbol("default-apollo-client");
var ApolloClients = Symbol("apollo-clients");
function resolveDefaultClient(providedApolloClients, providedApolloClient) {
    var resolvedClient = providedApolloClients ? providedApolloClients.default : providedApolloClient != null ? providedApolloClient : void 0;
    return resolvedClient;
}
function resolveClientWithId(providedApolloClients, clientId) {
    return providedApolloClients == null ? void 0 : providedApolloClients[clientId];
}
function useApolloClient(clientId) {
    var resolveImpl;
    var savedCurrentClients = currentApolloClients;
    if (!hasInjectionContext()) {
        resolveImpl = function (id) {
            if (id) {
                return resolveClientWithId(savedCurrentClients, id);
            }
            return resolveDefaultClient(savedCurrentClients, savedCurrentClients.default);
        };
    }
    else {
        var providedApolloClients_1 = inject(ApolloClients, null);
        var providedApolloClient_1 = inject(DefaultApolloClient, null);
        resolveImpl = function (id) {
            if (id) {
                var client2 = resolveClientWithId(providedApolloClients_1, id);
                if (client2) {
                    return client2;
                }
                return resolveClientWithId(savedCurrentClients, id);
            }
            var client = resolveDefaultClient(providedApolloClients_1, providedApolloClient_1);
            if (client) {
                return client;
            }
            return resolveDefaultClient(savedCurrentClients, savedCurrentClients.default);
        };
    }
    function resolveClient(id) {
        if (id === void 0) { id = clientId; }
        var client = resolveImpl(id);
        if (!client) {
            throw new Error("Apollo client with id ".concat(id != null ? id : "default", " not found. Use an app.runWithContext() or provideApolloClient() if you are outside of a component setup."));
        }
        return client;
    }
    return {
        resolveClient: resolveClient,
        get client() {
            return resolveClient();
        }
    };
}
var currentApolloClients = {};
function provideApolloClient(client) {
    currentApolloClients = {
        default: client
    };
    return function (fn) {
        var result = fn();
        currentApolloClients = {};
        return result;
    };
}
function provideApolloClients(clients) {
    currentApolloClients = clients;
    return function (fn) {
        var result = fn();
        currentApolloClients = {};
        return result;
    };
}
// src/useLazyQuery.ts
import { isRef as isRef3 } from "vue-demi";
// src/useQuery.ts
import { debounce, throttle } from "throttle-debounce";
import { computed as computed3, getCurrentInstance, getCurrentScope as getCurrentScope2, nextTick, onScopeDispose as onScopeDispose2, onServerPrefetch, ref as ref3, shallowRef, unref, watch as watch2 } from "vue-demi";
// src/util/env.ts
var isServer = typeof window === "undefined";
// src/util/loadingTracking.ts
import { getCurrentScope, onScopeDispose, ref, watch } from "vue-demi";
var globalTracking = {
    queries: ref(0),
    mutations: ref(0),
    subscriptions: ref(0),
    components: /* @__PURE__ */ new Map()
};
function getCurrentTracking() {
    var currentScope = getCurrentScope();
    if (!currentScope) {
        return {};
    }
    var tracking;
    if (isServer) {
        tracking = {
            queries: ref(0),
            mutations: ref(0),
            subscriptions: ref(0)
        };
        return { tracking: tracking };
    }
    if (!globalTracking.components.has(currentScope)) {
        globalTracking.components.set(currentScope, tracking = {
            queries: ref(0),
            mutations: ref(0),
            subscriptions: ref(0)
        });
        onScopeDispose(function () {
            globalTracking.components.delete(currentScope);
        });
    }
    else {
        tracking = globalTracking.components.get(currentScope);
    }
    return {
        tracking: tracking
    };
}
function track(loading, type) {
    if (isServer)
        return;
    var tracking = getCurrentTracking().tracking;
    watch(loading, function (value, oldValue) {
        if (oldValue != null && value !== oldValue) {
            var mod = value ? 1 : -1;
            if (tracking)
                tracking[type].value += mod;
            globalTracking[type].value += mod;
        }
    }, {
        immediate: true
    });
    onScopeDispose(function () {
        if (loading.value) {
            if (tracking)
                tracking[type].value--;
            globalTracking[type].value--;
        }
    });
}
function trackQuery(loading) {
    track(loading, "queries");
}
function trackMutation(loading) {
    track(loading, "mutations");
}
function trackSubscription(loading) {
    track(loading, "subscriptions");
}
// src/util/paramToReactive.ts
import { computed, isRef, reactive } from "vue-demi";
function paramToReactive(param) {
    if (isRef(param)) {
        return param;
    }
    else if (typeof param === "function") {
        return computed(param);
    }
    else if (param) {
        return reactive(param);
    }
    else {
        return param;
    }
}
// src/util/paramToRef.ts
import { computed as computed2, isRef as isRef2, ref as ref2 } from "vue-demi";
function paramToRef(param) {
    if (isRef2(param)) {
        return param;
    }
    else if (typeof param === "function") {
        return computed2(param);
    }
    else {
        return ref2(param);
    }
}
// src/util/toApolloError.ts
import { ApolloError, isApolloError } from "@apollo/client/core/index.js";
function toApolloError(error) {
    if (!(error instanceof Error)) {
        return new ApolloError({
            networkError: Object.assign(new Error(error == null ? void 0 : error.message), { originalError: error }),
            errorMessage: String(error)
        });
    }
    if (isApolloError(error)) {
        return error;
    }
    return new ApolloError({ networkError: error, errorMessage: error.message });
}
function resultErrorsToApolloError(errors) {
    return new ApolloError({
        graphQLErrors: errors,
        errorMessage: "GraphQL response contains errors: ".concat(errors.map(function (e) { return e.message; }).join(" | "))
    });
}
// src/util/useEventHook.ts
function useEventHook() {
    var fns = [];
    function on(fn) {
        fns.push(fn);
        return {
            off: function () { return off(fn); }
        };
    }
    function off(fn) {
        var index = fns.indexOf(fn);
        if (index !== -1) {
            fns.splice(index, 1);
        }
    }
    function trigger() {
        var e_1, _f;
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        try {
            for (var fns_1 = __values(fns), fns_1_1 = fns_1.next(); !fns_1_1.done; fns_1_1 = fns_1.next()) {
                var fn = fns_1_1.value;
                fn.apply(void 0, __spreadArray([], __read(params), false));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (fns_1_1 && !fns_1_1.done && (_f = fns_1.return)) _f.call(fns_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    function getCount() {
        return fns.length;
    }
    return {
        on: on,
        off: off,
        trigger: trigger,
        getCount: getCount
    };
}
// src/useQuery.ts
function useQuery(document, variables, options) {
    return useQueryImpl(document, variables, options);
}
function useQueryImpl(document, variables, options, lazy) {
    if (options === void 0) { options = {}; }
    if (lazy === void 0) { lazy = false; }
    var _a;
    var currentScope = getCurrentScope2();
    var currentInstance = getCurrentInstance();
    var currentOptions = ref3();
    var documentRef = paramToRef(document);
    var variablesRef = paramToRef(variables);
    var optionsRef = paramToReactive(options);
    var result = shallowRef();
    var resultEvent = useEventHook();
    var error = shallowRef(null);
    var errorEvent = useEventHook();
    var loading = ref3(false);
    currentScope && trackQuery(loading);
    var networkStatus = ref3();
    var firstResolve;
    var firstResolveTriggered = false;
    var firstReject;
    var firstRejectError;
    var tryFirstResolve = function () {
        firstResolveTriggered = true;
        if (firstResolve)
            firstResolve();
    };
    var tryFirstReject = function (apolloError) {
        firstRejectError = apolloError;
        if (firstReject)
            firstReject(apolloError);
    };
    var resetFirstResolveReject = function () {
        firstResolve = void 0;
        firstReject = void 0;
        firstResolveTriggered = false;
        firstRejectError = void 0;
    };
    currentInstance && ((_a = onServerPrefetch) == null ? void 0 : _a(function () {
        var _a2;
        if (!isEnabled.value || isServer && ((_a2 = currentOptions.value) == null ? void 0 : _a2.prefetch) === false)
            return;
        return new Promise(function (resolve, reject) {
            firstResolve = function () {
                resetFirstResolveReject();
                resolve();
            };
            firstReject = function (apolloError) {
                resetFirstResolveReject();
                reject(apolloError);
            };
            if (firstResolveTriggered) {
                firstResolve();
            }
            else if (firstRejectError) {
                firstReject(firstRejectError);
            }
        }).finally(stop);
    }));
    var resolveClient = useApolloClient().resolveClient;
    function getClient() {
        var _a2;
        return resolveClient((_a2 = currentOptions.value) == null ? void 0 : _a2.clientId);
    }
    var query = shallowRef();
    var observer;
    var started = false;
    var ignoreNextResult = false;
    var firstStart = true;
    function start() {
        var e_2, _f;
        var _a2, _b, _c, _d, _e;
        if (started || !isEnabled.value || isServer && ((_a2 = currentOptions.value) == null ? void 0 : _a2.prefetch) === false || !currentDocument) {
            tryFirstResolve();
            return;
        }
        if (isServer) {
            applyDocument(documentRef.value);
            applyVariables(variablesRef.value);
            applyOptions(unref(optionsRef));
        }
        started = true;
        error.value = null;
        loading.value = true;
        var client = getClient();
        query.value = client.watchQuery(__assign(__assign({ query: currentDocument, variables: currentVariables != null ? currentVariables : {} }, currentOptions.value), isServer && ((_b = currentOptions.value) == null ? void 0 : _b.fetchPolicy) !== "no-cache" ? {
            fetchPolicy: "network-only"
        } : {}));
        startQuerySubscription();
        if (!isServer && (firstStart || !((_c = currentOptions.value) == null ? void 0 : _c.keepPreviousResult)) && (((_d = currentOptions.value) == null ? void 0 : _d.fetchPolicy) !== "no-cache" || currentOptions.value.notifyOnNetworkStatusChange)) {
            var currentResult = query.value.getCurrentResult(false);
            if (!currentResult.loading || currentResult.partial || ((_e = currentOptions.value) == null ? void 0 : _e.notifyOnNetworkStatusChange)) {
                onNextResult(currentResult);
                ignoreNextResult = !currentResult.loading;
            }
            else if (currentResult.error) {
                onError(currentResult.error);
                ignoreNextResult = true;
            }
        }
        if (!isServer) {
            try {
                for (var subscribeToMoreItems_1 = __values(subscribeToMoreItems), subscribeToMoreItems_1_1 = subscribeToMoreItems_1.next(); !subscribeToMoreItems_1_1.done; subscribeToMoreItems_1_1 = subscribeToMoreItems_1.next()) {
                    var item = subscribeToMoreItems_1_1.value;
                    addSubscribeToMore(item);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (subscribeToMoreItems_1_1 && !subscribeToMoreItems_1_1.done && (_f = subscribeToMoreItems_1.return)) _f.call(subscribeToMoreItems_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        firstStart = false;
    }
    function startQuerySubscription() {
        if (observer && !observer.closed)
            return;
        if (!query.value)
            return;
        ignoreNextResult = false;
        observer = query.value.subscribe({
            next: onNextResult,
            error: onError
        });
    }
    function getErrorPolicy() {
        var _a2, _b, _c, _d;
        var client = resolveClient((_a2 = currentOptions.value) == null ? void 0 : _a2.clientId);
        return ((_b = currentOptions.value) == null ? void 0 : _b.errorPolicy) || ((_d = (_c = client.defaultOptions) == null ? void 0 : _c.watchQuery) == null ? void 0 : _d.errorPolicy);
    }
    function onNextResult(queryResult) {
        var _a2;
        if (ignoreNextResult) {
            ignoreNextResult = false;
            return;
        }
        error.value = null;
        processNextResult(queryResult);
        var errorPolicy = getErrorPolicy();
        if (errorPolicy && errorPolicy === "all" && !queryResult.error && ((_a2 = queryResult.errors) == null ? void 0 : _a2.length)) {
            processError(resultErrorsToApolloError(queryResult.errors));
        }
        tryFirstResolve();
    }
    function processNextResult(queryResult) {
        var _a2, _b;
        result.value = queryResult.data && Object.keys(queryResult.data).length === 0 ? queryResult.error && !((_a2 = currentOptions.value) == null ? void 0 : _a2.returnPartialData) && ((_b = currentOptions.value) == null ? void 0 : _b.errorPolicy) === "none" ? void 0 : result.value : queryResult.data;
        loading.value = queryResult.loading;
        networkStatus.value = queryResult.networkStatus;
        nextTick(function () {
            resultEvent.trigger(queryResult, {
                client: getClient()
            });
        });
    }
    function onError(queryError) {
        if (ignoreNextResult) {
            ignoreNextResult = false;
            return;
        }
        var apolloError = toApolloError(queryError);
        var errorPolicy = getErrorPolicy();
        if (errorPolicy && errorPolicy !== "none") {
            processNextResult(query.value.getCurrentResult());
        }
        processError(apolloError);
        tryFirstReject(apolloError);
        resubscribeToQuery();
    }
    function processError(apolloError) {
        error.value = apolloError;
        loading.value = false;
        networkStatus.value = 8;
        nextTick(function () {
            errorEvent.trigger(apolloError, {
                client: getClient()
            });
        });
    }
    function resubscribeToQuery() {
        if (!query.value)
            return;
        var lastError = query.value.getLastError();
        var lastResult = query.value.getLastResult();
        query.value.resetLastResults();
        startQuerySubscription();
        Object.assign(query.value, { lastError: lastError, lastResult: lastResult });
    }
    var onStopHandlers = [];
    function stop() {
        tryFirstResolve();
        if (!started)
            return;
        started = false;
        loading.value = false;
        onStopHandlers.forEach(function (handler) { return handler(); });
        onStopHandlers = [];
        if (query.value) {
            query.value.stopPolling();
            query.value = null;
        }
        if (observer) {
            observer.unsubscribe();
            observer = void 0;
        }
    }
    var restarting = false;
    function baseRestart() {
        if (!started || restarting)
            return;
        restarting = true;
        nextTick(function () {
            if (started) {
                stop();
                start();
            }
            restarting = false;
        });
    }
    var debouncedRestart;
    var isRestartDebounceSetup = false;
    function updateRestartFn() {
        var _a2, _b;
        if (!currentOptions.value) {
            debouncedRestart = baseRestart;
        }
        else {
            if ((_a2 = currentOptions.value) == null ? void 0 : _a2.throttle) {
                debouncedRestart = throttle(currentOptions.value.throttle, baseRestart);
            }
            else if ((_b = currentOptions.value) == null ? void 0 : _b.debounce) {
                debouncedRestart = debounce(currentOptions.value.debounce, baseRestart);
            }
            else {
                debouncedRestart = baseRestart;
            }
            isRestartDebounceSetup = true;
        }
    }
    function restart() {
        if (!started || restarting)
            return;
        if (!isRestartDebounceSetup)
            updateRestartFn();
        debouncedRestart();
    }
    var currentDocument = documentRef.value;
    var forceDisabled = ref3(lazy);
    var enabledOption = computed3(function () { return !currentOptions.value || currentOptions.value.enabled == null || currentOptions.value.enabled; });
    var isEnabled = computed3(function () { return enabledOption.value && !forceDisabled.value && !!documentRef.value; });
    watch2(function () { return unref(optionsRef); }, applyOptions, {
        deep: true,
        immediate: true
    });
    function applyOptions(value) {
        if (currentOptions.value && (currentOptions.value.throttle !== value.throttle || currentOptions.value.debounce !== value.debounce)) {
            updateRestartFn();
        }
        currentOptions.value = value;
        restart();
    }
    watch2(documentRef, applyDocument);
    function applyDocument(value) {
        currentDocument = value;
        restart();
    }
    var currentVariables;
    var currentVariablesSerialized;
    watch2(function () {
        if (isEnabled.value) {
            return variablesRef.value;
        }
        else {
            return void 0;
        }
    }, applyVariables, {
        deep: true,
        immediate: true
    });
    function applyVariables(value) {
        var serialized = JSON.stringify([value, isEnabled.value]);
        if (serialized !== currentVariablesSerialized) {
            currentVariables = value;
            restart();
        }
        currentVariablesSerialized = serialized;
    }
    function refetch(variables2) {
        if (variables2 === void 0) { variables2 = void 0; }
        if (query.value) {
            if (variables2) {
                currentVariables = variables2;
            }
            error.value = null;
            loading.value = true;
            return query.value.refetch(variables2).then(function (refetchResult) {
                var _a2;
                var currentResult = (_a2 = query.value) == null ? void 0 : _a2.getCurrentResult();
                currentResult && processNextResult(currentResult);
                return refetchResult;
            });
        }
    }
    function updateQuery(mapFn) {
        if (query.value) {
            query.value.updateQuery(mapFn);
        }
    }
    function fetchMore(options2) {
        if (query.value) {
            error.value = null;
            loading.value = true;
            return query.value.fetchMore(options2).then(function (fetchMoreResult) {
                var _a2;
                var currentResult = (_a2 = query.value) == null ? void 0 : _a2.getCurrentResult();
                currentResult && processNextResult(currentResult);
                return fetchMoreResult;
            });
        }
    }
    var subscribeToMoreItems = [];
    function subscribeToMore(options2) {
        if (isServer)
            return;
        var optionsRef2 = paramToRef(options2);
        watch2(optionsRef2, function (value, oldValue, onCleanup) {
            var index = subscribeToMoreItems.findIndex(function (item2) { return item2.options === oldValue; });
            if (index !== -1) {
                subscribeToMoreItems.splice(index, 1);
            }
            var item = {
                options: value,
                unsubscribeFns: []
            };
            subscribeToMoreItems.push(item);
            addSubscribeToMore(item);
            onCleanup(function () {
                item.unsubscribeFns.forEach(function (fn) { return fn(); });
                item.unsubscribeFns = [];
            });
        }, {
            immediate: true
        });
    }
    function addSubscribeToMore(item) {
        if (!started)
            return;
        if (!query.value) {
            throw new Error("Query is not defined");
        }
        var unsubscribe = query.value.subscribeToMore(item.options);
        onStopHandlers.push(unsubscribe);
        item.unsubscribeFns.push(unsubscribe);
    }
    watch2(isEnabled, function (value) {
        if (value) {
            nextTick(function () {
                start();
            });
        }
        else {
            stop();
        }
    });
    if (isEnabled.value) {
        start();
    }
    if (currentScope) {
        onScopeDispose2(function () {
            stop();
            subscribeToMoreItems.length = 0;
        });
    }
    else {
        console.warn("[Vue apollo] useQuery() is called outside of an active effect scope and the query will not be automatically stopped.");
    }
    return {
        result: result,
        loading: loading,
        networkStatus: networkStatus,
        error: error,
        start: start,
        stop: stop,
        restart: restart,
        forceDisabled: forceDisabled,
        document: documentRef,
        variables: variablesRef,
        options: optionsRef,
        query: query,
        refetch: refetch,
        fetchMore: fetchMore,
        subscribeToMore: subscribeToMore,
        updateQuery: updateQuery,
        onResult: resultEvent.on,
        onError: errorEvent.on
    };
}
// src/useLazyQuery.ts
function useLazyQuery(document, variables, options) {
    var query = useQueryImpl(document, variables, options, true);
    function load(document2, variables2, options2) {
        if (document2) {
            query.document.value = document2;
        }
        if (variables2) {
            query.variables.value = variables2;
        }
        if (options2) {
            Object.assign(isRef3(query.options) ? query.options.value : query.options, options2);
        }
        var isFirstRun = query.forceDisabled.value;
        if (isFirstRun) {
            query.forceDisabled.value = false;
            if (isServer) {
                query.start();
            }
            return new Promise(function (resolve, reject) {
                var offResult = query.onResult(function (result) {
                    if (!result.loading) {
                        resolve(result.data);
                        offResult();
                        offError();
                    }
                }).off;
                var offError = query.onError(function (error) {
                    reject(error);
                    offResult();
                    offError();
                }).off;
            });
        }
        else {
            return false;
        }
    }
    return __assign(__assign({}, query), { load: load });
}
// src/useLoading.ts
import { computed as computed4 } from "vue-demi";
function useQueryLoading() {
    var tracking = getCurrentTracking().tracking;
    if (!tracking)
        throw new Error("useQueryLoading must be called inside a setup function.");
    return computed4(function () { return tracking.queries.value > 0; });
}
function useMutationLoading() {
    var tracking = getCurrentTracking().tracking;
    if (!tracking)
        throw new Error("useMutationLoading must be called inside a setup function.");
    return computed4(function () { return tracking.mutations.value > 0; });
}
function useSubscriptionLoading() {
    var tracking = getCurrentTracking().tracking;
    if (!tracking)
        throw new Error("useSubscriptionLoading must be called inside a setup function.");
    return computed4(function () { return tracking.subscriptions.value > 0; });
}
function useGlobalQueryLoading() {
    return computed4(function () { return globalTracking.queries.value > 0; });
}
function useGlobalMutationLoading() {
    return computed4(function () { return globalTracking.mutations.value > 0; });
}
function useGlobalSubscriptionLoading() {
    return computed4(function () { return globalTracking.subscriptions.value > 0; });
}
// src/useMutation.ts
import { getCurrentScope as getCurrentScope3, isRef as isRef4, nextTick as nextTick2, onScopeDispose as onScopeDispose3, ref as ref4, shallowRef as shallowRef2 } from "vue-demi";
function useMutation(document, options) {
    if (options === void 0) { options = {}; }
    var currentScope = getCurrentScope3();
    var loading = ref4(false);
    currentScope && trackMutation(loading);
    var error = shallowRef2(null);
    var called = ref4(false);
    var doneEvent = useEventHook();
    var errorEvent = useEventHook();
    var resolveClient = useApolloClient().resolveClient;
    function mutate(variables_1) {
        return __awaiter(this, arguments, void 0, function (variables, overrideOptions) {
            var currentDocument, currentOptions, client, result, e_3, apolloError;
            if (overrideOptions === void 0) { overrideOptions = {}; }
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (typeof document === "function") {
                            currentDocument = document();
                        }
                        else if (isRef4(document)) {
                            currentDocument = document.value;
                        }
                        else {
                            currentDocument = document;
                        }
                        if (typeof options === "function") {
                            currentOptions = options();
                        }
                        else if (isRef4(options)) {
                            currentOptions = options.value;
                        }
                        else {
                            currentOptions = options;
                        }
                        client = resolveClient(currentOptions.clientId);
                        error.value = null;
                        loading.value = true;
                        called.value = true;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 4, , 6]);
                        return [4 /*yield*/, client.mutate(__assign(__assign(__assign({ mutation: currentDocument }, currentOptions), overrideOptions), { variables: (variables != null ? variables : currentOptions.variables) ? __assign(__assign({}, currentOptions.variables), variables) : void 0 }))];
                    case 2:
                        result = _f.sent();
                        loading.value = false;
                        return [4 /*yield*/, nextTick2()];
                    case 3:
                        _f.sent();
                        doneEvent.trigger(result, {
                            client: client
                        });
                        return [2 /*return*/, result];
                    case 4:
                        e_3 = _f.sent();
                        apolloError = toApolloError(e_3);
                        error.value = apolloError;
                        loading.value = false;
                        return [4 /*yield*/, nextTick2()];
                    case 5:
                        _f.sent();
                        errorEvent.trigger(apolloError, {
                            client: client
                        });
                        if (currentOptions.throws === "always" || currentOptions.throws !== "never" && !errorEvent.getCount()) {
                            throw apolloError;
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    }
    currentScope && onScopeDispose3(function () {
        loading.value = false;
    });
    return {
        mutate: mutate,
        loading: loading,
        error: error,
        called: called,
        onDone: doneEvent.on,
        onError: errorEvent.on
    };
}
// src/useResult.ts
import { computed as computed5 } from "vue-demi";
function useResult(result, defaultValue, pick) {
    console.warn("'useResult' is deprecated and will be removed soon. Please use 'computed' instead.\nBefore:\nconst items = useResult(result, [], data => data.someField.myItems)\nAfter:\nconst items = computed(() => result.value?.someField.myItems ?? [])");
    return computed5(function () {
        var value = result.value;
        if (value) {
            if (pick) {
                try {
                    return pick(value);
                }
                catch (e) {
                }
            }
            else {
                var keys = Object.keys(value);
                if (keys.length === 1) {
                    return value[keys[0]];
                }
                else {
                    return value;
                }
            }
        }
        return defaultValue;
    });
}
// src/useSubscription.ts
import { debounce as debounce2, throttle as throttle2 } from "throttle-debounce";
import { computed as computed6, getCurrentScope as getCurrentScope4, isRef as isRef5, nextTick as nextTick3, onScopeDispose as onScopeDispose4, ref as ref5, shallowRef as shallowRef3, watch as watch3 } from "vue-demi";
function useSubscription(document, variables, options) {
    if (variables === void 0) { variables = void 0; }
    if (options === void 0) { options = {}; }
    var currentScope = getCurrentScope4();
    var documentRef = paramToRef(document);
    var variablesRef = paramToRef(variables);
    var optionsRef = paramToReactive(options);
    var result = shallowRef3();
    var resultEvent = useEventHook();
    var error = shallowRef3(null);
    var errorEvent = useEventHook();
    var loading = ref5(false);
    currentScope && trackSubscription(loading);
    var resolveClient = useApolloClient().resolveClient;
    var subscription = ref5(null);
    var observer = null;
    var started = false;
    function getClient() {
        var _a;
        return resolveClient((_a = currentOptions.value) == null ? void 0 : _a.clientId);
    }
    function start() {
        if (started || !isEnabled.value || isServer)
            return;
        started = true;
        loading.value = true;
        var client = getClient();
        subscription.value = client.subscribe(__assign({ query: currentDocument, variables: currentVariables }, currentOptions.value));
        observer = subscription.value.subscribe({
            next: onNextResult,
            error: onError
        });
    }
    function onNextResult(fetchResult) {
        result.value = fetchResult.data;
        loading.value = false;
        resultEvent.trigger(fetchResult, {
            client: getClient()
        });
    }
    function onError(fetchError) {
        var apolloError = toApolloError(fetchError);
        error.value = apolloError;
        loading.value = false;
        errorEvent.trigger(apolloError, {
            client: getClient()
        });
    }
    function stop() {
        if (!started)
            return;
        started = false;
        loading.value = false;
        if (subscription.value) {
            subscription.value = null;
        }
        if (observer) {
            observer.unsubscribe();
            observer = null;
        }
    }
    var restarting = false;
    function baseRestart() {
        if (!started || restarting)
            return;
        restarting = true;
        nextTick3(function () {
            if (started) {
                stop();
                start();
            }
            restarting = false;
        });
    }
    var debouncedRestart;
    function updateRestartFn() {
        var _a, _b;
        if ((_a = currentOptions.value) == null ? void 0 : _a.throttle) {
            debouncedRestart = throttle2(currentOptions.value.throttle, baseRestart);
        }
        else if ((_b = currentOptions.value) == null ? void 0 : _b.debounce) {
            debouncedRestart = debounce2(currentOptions.value.debounce, baseRestart);
        }
        else {
            debouncedRestart = baseRestart;
        }
    }
    function restart() {
        if (!debouncedRestart)
            updateRestartFn();
        debouncedRestart();
    }
    var currentOptions = ref5();
    watch3(function () { return isRef5(optionsRef) ? optionsRef.value : optionsRef; }, function (value) {
        if (currentOptions.value && (currentOptions.value.throttle !== value.throttle || currentOptions.value.debounce !== value.debounce)) {
            updateRestartFn();
        }
        currentOptions.value = value;
        restart();
    }, {
        deep: true,
        immediate: true
    });
    var currentDocument;
    watch3(documentRef, function (value) {
        currentDocument = value;
        restart();
    }, {
        immediate: true
    });
    var currentVariables;
    var currentVariablesSerialized;
    watch3(variablesRef, function (value, oldValue) {
        var serialized = JSON.stringify(value);
        if (serialized !== currentVariablesSerialized) {
            currentVariables = value;
            restart();
        }
        currentVariablesSerialized = serialized;
    }, {
        deep: true,
        immediate: true
    });
    var enabledOption = computed6(function () { return !currentOptions.value || currentOptions.value.enabled == null || currentOptions.value.enabled; });
    var isEnabled = enabledOption;
    watch3(isEnabled, function (value) {
        if (value) {
            start();
        }
        else {
            stop();
        }
    }, {
        immediate: true
    });
    if (currentScope) {
        onScopeDispose4(stop);
    }
    else {
        console.warn("[Vue apollo] useSubscription() is called outside of an active effect scope and the subscription will not be automatically stopped.");
    }
    return {
        result: result,
        loading: loading,
        error: error,
        // @TODO doesn't fully work yet
        // enabled,
        start: start,
        stop: stop,
        restart: restart,
        document: documentRef,
        variables: variablesRef,
        options: optionsRef,
        subscription: subscription,
        onResult: resultEvent.on,
        onError: errorEvent.on
    };
}
export { ApolloClients, DefaultApolloClient, provideApolloClient, provideApolloClients, useApolloClient, useGlobalMutationLoading, useGlobalQueryLoading, useGlobalSubscriptionLoading, useLazyQuery, useMutation, useMutationLoading, useQuery, useQueryLoading, useResult, useSubscription, useSubscriptionLoading };
//# sourceMappingURL=index.mjs.map
